import { Form } from 'react-bootstrap';
import type { SingleValue } from 'react-select';
import { AliasChipsField } from '../AliasChipsField';
import { SetupDomainSelect } from './SetupDomainSelect';
import type { SetupDomainOptionData } from './types';

type SetupInfoStepProps = {
  domainOptions: SetupDomainOptionData[];
  selectedDomainOption: SetupDomainOptionData | null;
  onDomainChange: (option: SingleValue<SetupDomainOptionData>) => void;
  onAddDomain: () => void;
  aliases: string[];
  onAddAlias: (name: string) => void;
  onRemoveAlias: (index: number) => void;
  onSubmit: (e?: React.FormEvent) => void;
};

export function SetupInfoStep({
  domainOptions,
  selectedDomainOption,
  onDomainChange,
  onAddDomain,
  aliases,
  onAddAlias,
  onRemoveAlias,
  onSubmit,
}: SetupInfoStepProps) {
  return (
    <Form
      id="setup-info-form"
      onSubmit={(e) => void onSubmit(e)}
      className="d-flex flex-column gap-3"
    >
      <SetupDomainSelect
        options={domainOptions}
        value={selectedDomainOption}
        onChange={onDomainChange}
        onAddDomain={onAddDomain}
      />

      <AliasChipsField
        aliases={aliases}
        onAdd={onAddAlias}
        onRemove={onRemoveAlias}
        showHelp
      />
    </Form>
  );
}
